import { Button } from '@main/pc-core-components/src/Button';
import { buttonReset } from '@main/pc-core-components/src/Button/wrappers';
import styled from 'styled-components';

/**
 * This button is meant to be used for accessible actions.
 * For example, you might have an icon that has an onClick
 * handler on it. The onClick handler does a certain action.
 *
 * In order to make that icon accessible, wrap it with this
 * button so that the user can use their keyboard to focus
 * on it both visually and functionally, as well as trigger
 * the onClick by hitting enter on their keyboard.
 *
 * EXAMPLE
 *
 * Before (not accessible):
 *  <div onClick={doSomething}>
 *    <svg></svg>
 *  </div>
 *
 * After (accessible):
 *  <FocusButton onClick={doSomething}>
 *     <svg></svg>
 *  </FocusButton>
 */
export const FocusButton = styled(Button)`
  ${buttonReset}

  &:hover,
  &:active,
  &:focus {
    background-color: unset;
    border: unset;
  }
`;
